import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ProjectSummary {
  id: string;
  name: string;
  projectKey: string;
  projectType: string;
}

interface ProjectState {
  currentProject: ProjectSummary | null;
  setCurrentProject: (project: ProjectSummary | null) => void;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set) => ({
      currentProject: null,
      setCurrentProject: (project) => set({ currentProject: project }),
    }),
    { name: 'maios-project' },
  ),
);
